import { useRef, useState } from "react";

export default function Filter({
  records,
  search,
  totalWithdrawal
}) {
  const searchRef = useRef();

  const formatCurrency = (num) => {
    return Number(num || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const total = Number(totalWithdrawal || 0);

  const [searchuser, setSearchUser] = useState("");

  return (
    <div className="filter px-4">
      <div className="filterleft">
        <button className={"NavLinkBtn hover marginright unselectlink"}>
          Records : {records}
        </button>
        <button className="NavLinkBtn hover white"
        style={{
          backgroundColor : "#FF4445"
        }}
        >
          Total : ₹ {formatCurrency(total)}
        </button>
      </div>

      <div className="filterright">
        <div className="margin-right">
          <input
            ref={searchRef}
            type="text"
            name="search"
            id="search"
            autoComplete="new-password"
            placeholder="Search Acc/Name/User"
            class="input bg-[var(--background)] border-2 h-7 border-[var(--hover)] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white "
            value={searchuser}
            onChange={(e) => {
              setSearchUser(e.target.value);
              search(e.target.value);
            }}
          />
        </div>
      </div>
    </div>
  );
}
